// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__xYcYW","title":"Images45_title__2UVT7","images":"Images45_images__2qYCe"};